import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ServiceItem from '../service-item';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const ServiceItemWrapper = ({ item }) => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper className="service-item-wrapper">
                <ServiceItem serviceItem={item} />
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default ServiceItemWrapper;
